import { Navigate } from 'react-router-dom'

import { useCurrentEvent } from './eventContext'

/**
 * The `/events/:id` index redirect. A poker-only (POKER) event is operational,
 * not golf — its home is the Poker tab (clock + players), not a golf summary.
 * Every other mode lands on the summary as before.
 */
const EventHomeRedirect = () => {
  const event = useCurrentEvent()
  const home = event.mode === 'POKER' ? 'poker' : 'summary'
  return <Navigate to={`/events/${event.id}/${home}`} replace />
}

export default EventHomeRedirect
